import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { getStoreUrl } from '../utils/storeUrls';

const Footer = () => {
  const { t, i18n } = useTranslation();
  
  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-16 dark:bg-slate-900 dark:border-slate-800">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {/* Left side */}
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4 dark:text-white">
              {t('footer.downloadTitle')} {/Android/.test(navigator.userAgent) ? t('footer.googlePlay') : t('footer.appStore')}
            </h2>
            <a
              href={getStoreUrl(i18n.language)}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-900 text-white px-6 py-3 rounded-full inline-flex items-center gap-2 hover:bg-black transition-colors"
            >
              {t('footer.downloadFreeApp')}
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>

          {/* Right side - Links */}
          <div className="flex flex-col items-start md:items-end gap-4">
            <a href="/terms" className="text-gray-500 hover:text-gray-900 transition-colors dark:text-gray-400 dark:hover:text-white">
              {t('footer.termsOfUse')}
            </a>
            <a href="/privacy" className="text-gray-500 hover:text-gray-900 transition-colors dark:text-gray-400 dark:hover:text-white">
              {t('footer.privacyPolicy')}
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-gray-500 text-sm">
          {t('footer.copyright', { year: new Date().getFullYear() })}
        </div>
      </div>
    </footer>
  );
};

export default Footer;